// @flow

import {Tag} from 'docs/util';
import type {MarkdocFragmentRegistration} from 'docs/markdoc';

export const PageSelectorOption: MarkdocFragmentRegistration = {
  tag: 'page-selector-option',
  attributes: {
    title: {
      type: String,
      required: true,
      localizable: true,
      description: 'The text to display on the option',
    },
    prefs: {
      type: Object,
      required: true,
      description: 'The prefs to set when the option is chosen',
    },
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);
    return new Tag(this.tag, attributes, children);
  },
};
